// Sites an activation link can open. Shared by the create/edit form and the reactivate dialog.
export const WEBSITE_REDIRECT_OPTIONS = [
  { label: "Global Website", value: process.env.REACT_APP_GLOBAL_WEBSITE_URL },
  { label: "Takeda Website", value: process.env.REACT_APP_TAKEDA_WEBSITE_URL },
  { label: "Organon Website", value: process.env.REACT_APP_ORGANON_WEBSITE_URL },
];
